import React from 'react'

const Banner = ({language}) => {
    return (
        <section className="become-part-banner">
            <div className="become-part-header">
                <h1>{language === "Chinese" ? "成為合作夥伴" : "BECOME A PARTNER"}</h1>
            </div>
            <div className="become-part-banner2">
                <div className="become-part-txtx">
                    <h2><em>{language === "Chinese" ? "成為環法自行車挑戰賽 紐崔萊日月潭站合作夥伴" : "BECOME AN L’ÉTAPE SUN MOON LAKE PARTNER"}</em></h2>
                    {language === "Chinese" ? <p>
                        邀請您成為我們的合作夥伴！ <br />
                        讓您的品牌為經典賽事增加亮點 <br />
                        2026 第三屆環法自行車挑戰賽日月潭站 <br />
                        持續打造國際化運動賽事體驗
                    </p> : <p>
                        We invite you to become our partner!<br />
                        Let your brand shine at a legendary event.<br />
                        The 3rd edition of L’Étape Sun Moon Lake by Tour de France in 2026<br/>
                        continues to deliver a world-class international sporting experience.
                    </p>}
                    
                    <button><strong>EXPERIENCE THE TOUR DE FRANCE LEGEND</strong></button>
                </div>
            </div>
        </section>
    )
}

export default Banner